import { IMessenger } from "interfaces/messenger";
import api from "./api";
/**
 * API: Retornar todas as mensagens
 */

export async function getAllMessengers(): Promise<{
  data: IMessenger[];
  status: number;
}> {
  try {
    const { data, status } = await api.get("/messenger/list");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Muda o status das mensagens
 */

export async function updateStatusMessanger(id: number) {
  try {
    const { data, status } = await api.patch(`/messenger/status/${id}`);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Deletar uma mensagem
 */
export async function deleteMessenger(id: number) {
  try {
    const { data, status } = await api.delete(`/messenger/delete/${id}`);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
